var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmIconUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lucide Icons / users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.6667 40.25V36.4167C30.6667 34.3833 29.8589 32.4333 28.4212 30.9955C26.9834 29.5577 25.0333 28.75 23 28.75H11.5C9.46667 28.75 7.51663 29.5577 6.07885 30.9955C4.64107 32.4333 3.83333 34.3833 3.83333 36.4167V40.25M42.1667 40.2498V36.4164C42.1654 34.7178 41.6 33.0676 40.5593 31.725C39.5186 30.3825 38.0614 29.4236 36.4167 28.9989M30.6667 5.99894C32.3158 6.42119 33.7775 7.38029 34.8213 8.72504C35.8651 10.0698 36.4317 11.7237 36.4317 13.426C36.4317 15.1284 35.8651 16.7823 34.8213 18.127C33.7775 19.4718 32.3158 20.4309 30.6667 20.8531M24.9167 13.4167C24.9167 17.6508 21.4842 21.0833 17.25 21.0833C13.0158 21.0833 9.58333 17.6508 9.58333 13.4167C9.58333 9.18248 13.0158 5.75 17.25 5.75C21.4842 5.75 24.9167 9.18248 24.9167 13.4167Z",
    stroke: "#FFE743",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmIconUsers);
export default __webpack_public_path__ + "static/media/hmIconUsers.d98c236c9776c05f1557c6b6f457433e.svg";
export { ForwardRef as ReactComponent };